
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({name: 'PurchaseOrderFee'})
export default class PurchaseOrderFee extends Vue {
  @Prop({ default: true }) private getButtonTrue: boolean;

  private table =  {
    loading: false,
    list: [],
    tableCol: [
      {
        label: "采购订单号",
        prop: "purchaseOrderCode",
        key: "purchaseOrderCode",
        show: true,
        disabled: false,
      },
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "本次分配金额",
        prop: "thisDistributionAmount",
        key: "thisDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "待分配",
        prop: "toDistributionAmount",
        key: "toDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "总费用",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "操作",
        prop: "action",
        type: "icon_delete",
        icon: "el-icon-delete",
        click: "handleDelete",
        show: true,
        disabled: false,
      },
    ],
    tableCol1: [
      {
        label: "采购订单号",
        prop: "purchaseOrderCode",
        key: "purchaseOrderCode",
        show: true,
        disabled: false,
      },
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "本次分配金额",
        prop: "thisDistributionAmount",
        key: "thisDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "待分配",
        prop: "toDistributionAmount",
        key: "toDistributionAmount",
        show: true,
        disabled: false,
      },
      {
        label: "总费用",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
    ],
  };

  private relationPurchaseOrderFeeGIVE(list) {
    this.table.list = list
  }
}
